import { Axios, MutationConfig } from '@helpers';
import { useMutation } from 'react-query';

export const uploadEvidence = ({
  data,
  modelId,
  id,
}: {
  data: File;
  modelId: string;
  id: string;
}) => {
  const formData = new FormData();
  formData.append('file', data);
  return Axios.post(`/admin/models/${modelId}/social-media-links/${id}/evidence`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

type UseUpdateEvidence = {
  mutationConfig?: MutationConfig<typeof uploadEvidence>;
};

export const useUpdateEvidence = ({ mutationConfig }: UseUpdateEvidence = {}) => {
  const { onSuccess, ...restConfig } = mutationConfig || {};
  return useMutation({
    onSuccess: (...args) => {
      onSuccess?.(...args);
    },
    ...restConfig,
    mutationFn: uploadEvidence,
  });
};
